// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let ViewStack = require("../../reason/common/ViewStack.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BuyerNeedPropertyAttributes_buyerNeedV5_graphql = require("../../__generated__/BuyerNeedPropertyAttributes_buyerNeedV5_graphql.bs.js");
let BuyerNeedPropertyAttributes_propertyTypes_graphql = require("../../__generated__/BuyerNeedPropertyAttributes_propertyTypes_graphql.bs.js");

let convertFragment = BuyerNeedPropertyAttributes_propertyTypes_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, fRef);
}

let PropertyTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerNeedPropertyAttributes$Attributes(props) {
  let __icon = props.icon;
  let minBeds = props.minBeds;
  let icon = __icon !== undefined ? Primitive_option.valFromOption(__icon) : "home";
  let propertyTypes = RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_propertyTypes_graphql.node, convertFragment, props.propertyTypes);
  let __x = propertyTypes.map(x => x.displayName);
  return JsxRuntime.jsxs(ViewStack.make, {
    flexDirection: "row",
    children: [
      JsxRuntime.jsxs(ViewStack.make, {
        space: "sm",
        flexDirection: "row",
        children: [
          Stdlib_Option.getOr(Stdlib_Option.map(icon, icon => JsxRuntime.jsx(IconV5.make, {
            icon: icon,
            className: "text-zinc-600"
          })), null),
          JsxRuntime.jsx("span", {
            children: Utils.$$Array.pseudoJoin(", ", " or ", __x).join(""),
            className: "text-zinc-700"
          })
        ]
      }),
      minBeds !== undefined ? JsxRuntime.jsxs(ViewStack.make, {
          space: "sm",
          flexDirection: "row",
          children: [
            JsxRuntime.jsx(IconV5.make, {
              icon: "bed",
              className: "relative top-0.5 text-zinc-600"
            }),
            JsxRuntime.jsx("span", {
              children: minBeds.toString() + `+`,
              className: "text-zinc-700"
            })
          ]
        }) : null
    ]
  });
}

let Attributes = {
  PropertyTypeFragment: PropertyTypeFragment,
  make: BuyerNeedPropertyAttributes$Attributes
};

let convertFragment$1 = BuyerNeedPropertyAttributes_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function BuyerNeedPropertyAttributes(props) {
  let match = RescriptRelay_Fragment.useFragment(BuyerNeedPropertyAttributes_buyerNeedV5_graphql.node, convertFragment$1, props.buyerNeed);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property criteria",
    children: JsxRuntime.jsx(BuyerNeedPropertyAttributes$Attributes, {
      propertyTypes: match.propertyTypes.map(v => v.fragmentRefs),
      minBeds: match.minBeds,
      icon: props.icon
    })
  });
}

let make = BuyerNeedPropertyAttributes;

exports.Attributes = Attributes;
exports.Fragment = Fragment;
exports.make = make;
/* Utils Not a pure module */
